function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.337 31.663H6.663a6.339 6.339 0 01-6.333-6.33V6.667c0-3.49 2.84-6.33 6.333-6.33h18.674a6.339 6.339 0 016.333 6.33v18.666c0 3.49-2.841 6.33-6.333 6.33zM6.663 2.33a4.343 4.343 0 00-4.339 4.337v18.666a4.343 4.343 0 004.339 4.337h18.674a4.343 4.343 0 004.339-4.337V6.667a4.343 4.343 0 00-4.339-4.337H6.663z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.671 16.91c.55 0 .997-.446.997-.997C27.668 9.482 22.434 4.25 16 4.25c-6.434 0-11.668 5.232-11.668 11.663 0 .55.446.997.997.997H26.67zm-11.668-1.993H6.378A9.622 9.622 0 018.494 9.82l1.465 1.464v.002a1 1 0 001.41 0l.001-.002a.997.997 0 000-1.409L9.904 8.411a9.634 9.634 0 015.099-2.117V8.58a.997.997 0 001.994 0V6.294a9.632 9.632 0 015.1 2.116L20.63 9.876a.997.997 0 000 1.41h.001a1 1 0 001.409 0l1.466-1.467a9.623 9.623 0 012.118 5.098h-8.627v-1.67a.997.997 0 00-1.994 0v1.67z",
  fill: "currentColor"
})));